import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, AthleteStatus } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAthleteStatuses {
  athlete?: string;
}

function useAthleteStatuses({
  athlete,
}: IUseAthleteStatuses): UseQueryResult<{ data: Array<AthleteStatus> }> {
  const params: UrlParams = {};

  if (athlete) {
    params.athlete = athlete;
  }

  return useQuery(
    ['athleteStatuses', athlete],
    () => client.get(`athlete-statuses/?${encodeUrlParams(params)}`),
    { enabled: !!athlete },
  );
}

export default useAthleteStatuses;
